import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { hideLoader, showLoader } from '../../components/Loader/loaderSlice';
import { CreateEditModal, Notifications, TableDropdownButton } from '../../components';
import ListTable, { ColumnProps } from '../../components/ListTable';
import { HarvestsService, NotificationsService } from '../../services';
import { useDataMatch } from '../../hooks';
import { Harvest } from '../../@types/harvest';
import CreateEditPage from './CreateEditPage';

const HarvestPage: React.FC<PropTypes> = ({ match, history }) => {
  const dispatch = useDispatch();
  const [harvests, setHarvests] = useState<Harvest[]>([]);
  const [dropdownOpened, setDropdownOpened] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const isCreatingEditing = useDataMatch(match.params.action, ['novo', 'editar']);

  const deleteNotification = (id: string, description: string) => NotificationsService.custom({
    message: <Notifications.Button
      text={<>Você tem certeza que deseja excluir <b>{description}</b>?</>}
      onClickYes={() => onConfirmDelete(id)}
    />,
  });

  const onConfirmDelete = async (id: string) => {
    try {
      await HarvestsService.remove(id);
      loadHarvests();
    } catch (error) {
      console.error(error);
      NotificationsService.error({ message: 'Falha ao excluir Safra' });
    }
  };

  const columns: ColumnProps<Harvest>[] = [{
    field: 'description',
    header: 'Descrição',
  },
  {
    field: 'current',
    header: 'Atual',
    body: ({ current }: Harvest) => (current ? 'Sim' : 'Não'),
  },
  {
    header: '',
    body: ({ description, uuid, id }: Harvest) => (
      <TableDropdownButton
        isActive={dropdownOpened === uuid}
        onClickOver={() => setDropdownOpened('')}
        onClickDropdownButton={() => setDropdownOpened(dropdownOpened ? '' : uuid)}
        redirectOnClickEdit={`/safras/editar/${id}`}
        onClickDelete={() => deleteNotification(id, description)}
      />
    ),
    sortable: false,
    className: 'options-column',
  }];

  const loadHarvests = async () => {
    dispatch(showLoader());
    try {
      setHarvests(await HarvestsService.find(''));
    } catch (error) {
      NotificationsService.error({ message: 'Falha ao carregar Lista de Safras' });
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadHarvests(); }, []);

  useEffect(() => {
    setModalVisible(isCreatingEditing);
  }, [isCreatingEditing]);

  return (
    <div className="harvests">
      <div className="page-title">
        <h1 className="title">Safras</h1>
      </div>
      <div>
        <div className="buttons is-right">
          <p className="control">
            <Link className="button is-link" to="/safras/novo">Adicionar Safra</Link>
          </p>
        </div>
        <CreateEditModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          onClosed={() => history.push('/safras')}
          title={`${match.params.id ? 'Edição' : 'Criação'} de Safra`}
        >
          <CreateEditPage
            id={match.params.id}
            onClose={() => setModalVisible(false)}
            onSave={loadHarvests}
          />
        </CreateEditModal>
        <ListTable
          columns={columns}
          data={harvests}
          showUUID
        />
      </div>
    </div>
  );
};

export default HarvestPage;

type PropTypes = RouteComponentProps<RouteParams>;

type RouteParams = {
  action?: 'novo' | 'editar',
  id?: string,
};
